import { createSelector } from '@ngrx/store';

import * as fromFeature from '@app/core/store/reducers';

export const getRouterState = createSelector(
  fromFeature.selectCoreState,
  (state: fromFeature.State) => state.routerReducer
);
